module.exports = __webpack_public_path__ + "static/media/qab_services_android.5278421c.png";